import request from '@/api/axios';

// 获取购物车列表
const getCartList = (params: object) => {
  params.type = 0
  params.isApi2 = true;
  return request({
      url: '/commodity/center/cart/list',
      method: 'get',
      data: params
  });
};
// 获取购物车总数
const getCartTotal = (data: object) => {
  data.isApi2 = true;
  return request({
      url: '/commodity/center/cart/total',
      method: 'get',
      data: data
  });
};
// 添加购物车
const addCartList = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/cart/save',
      method: 'post',
      data: params
  });
};

// 更新购物车状态
const updateCartList = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/cart/update',
      method: 'post',
      data: params
  });
};
// 删除
const deleteCart = (params: object) => {
  params.isApi2 = true
  return request({
    url: '/commodity/center/cart/remove',
    method: 'get',
    data: params
  })
}
// 删除全部
const deleteAllCart = (params: object) => {
  params.isApi2 = true
  return request({
    url: '/commodity/center/cart/batch/remove',
    method: 'post',
    data: params
  })
}

// 添加进商品清单
const addSampleChecklist = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/sampleChecklist/save',
      method: 'post',
      data: params
  });
};
// 获取商品清单总数
const getCanSampleApplyTotal = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/sampleChecklist/total',
      method: 'get',
      data: params
  });
};

// 获取商品清单列表
const getCanSampleApplyList = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/sampleChecklist/list',
      method: 'get',
      data: params
  });
};
// 删除
const deleteCanSampleApply = (params: object) => {
  params.isApi2 = true
  return request({
    url: '/commodity/center/sampleChecklist/remove',
    method: 'post',
    data: params
  })
}
// 更新样品清单
const updateCanSampleApplyList = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/commodity/center/sampleChecklist/update',
      method: 'post',
      data: params
  });
};

let ShopsApi = {
  getCartList,
  getCartTotal,
  addCartList,
  updateCartList,
  deleteCart,
  deleteAllCart,
  addSampleChecklist,
  getCanSampleApplyTotal,
  getCanSampleApplyList,
  deleteCanSampleApply,
  updateCanSampleApplyList,
}
export default ShopsApi